module.exports = __webpack_public_path__ + "static/testimonialLayout2Front-2195cbdeb8597198ca209daa20868182.png";